<template>
<div>
<div>
  <v-app id="inspire">
    <v-content>
      <v-container  fluid>
              <div>
                <template>
                  <v-row>
                    <v-col cols="12" md="3">
  <v-expansion-panels>
    <v-expansion-panel
      v-for="(items,i) in tipoRelatorios"
      :key="i"
    >
     <v-row>
                      <v-col cols="12" md="12">
      <v-expansion-panel-header @click="relatoriosVendas(items)">{{items.descricao}}</v-expansion-panel-header>
      <v-expansion-panel-content>

          </v-expansion-panel-content>
           </v-col>

                  </v-row>
    </v-expansion-panel>

  </v-expansion-panels>
                    </v-col>

                    <!--Form -->
                     <v-col cols="12" md="9">
<!-- Ínicio Produto -->
          <v-row align="center" justify="center" v-if="callFormProduto">
          <v-col cols="12" sm="8" md="12">
              <h2>  {{this.relatorio_Dados.especificacaoRelatorio.descricao}} </h2>
              <v-card-text>
              <div>
                   <v-row >

                          <v-form ref="form" v-model="valid"  lazy-validation>
                   <v-row >
                       <!-- Ínicio Date Picker-->
          <v-col cols="12" md="3">
             <v-menu
         ref="menu"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field
        v-model="date1"
        :rules="ruleTextRequired"
        label="Data ínicio"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date1"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
                       </v-col>
                        <v-col cols="12" md="3">
          <v-menu
         ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date2"
        :rules="ruleTextRequired"
        label="Data ínicio"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date2"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
      <span style="color:red" v-if="periodo > 10"> {{msg1}}</span>
      <span style="color:red" v-if="(-anoMesDia1+anoMesDia2) < 0"> {{msg2}}</span>
                       </v-col>

<!-- Fim Date Picker-->
<v-col cols="12" md="3">
   <v-autocomplete
        v-model="grupo_produto"
        :rules="ruleTextRequired"
        item-value="pkFamiliaProduto"
        item-text="descricao"
        :items="grupo_produtos"
        label="Familia"
        :readonly="false"
        persistent-hint
        prepend-icon="person"
        return-object
      >
 </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="3">
          <v-autocomplete
        v-model="produto"
         :rules="ruleTextRequired"
        item-value="pkProduto"
        item-text="descricao"
        :items="produtos"
        :readonly="false"
        label="Produto"
        persistent-hint
        prepend-icon="mdi-city"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                   <v-col cols="12" md="3">
                         <v-select
          v-model="estado"
              item-value="pkEstado"
              item-text="descricao"
              :items="estados"
          label="Estado"
              return-object
        ></v-select>

                  </v-col>
                   <v-col cols="12" md="3">
                         <v-select
          v-model="situacao"
              item-value="pkSituacao"
              item-text="descricao"
              :items="situacoes"
          label="Situação"
          disabled
              return-object
        ></v-select>

                  </v-col>
                   <v-col cols="12" md="3">
          <v-autocomplete
        v-model="fornecedor"
         :rules="ruleTextRequired"
        item-value="pkFornecedor"
        item-text="nome"
        :items="fornecedores"
        :readonly="false"
        label="Fornecedor"
        persistent-hint
        prepend-icon="mdi-city"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                  <v-col cols="12" md="3">
                         <v-select
          v-model="armazem"
              item-value="pkArmazem"
              item-text="descricao"
              :items="armazens"
          label="Armazém"
              return-object
        ></v-select>

                  </v-col>
                  <v-col cols="12" md="3">
                         <v-select
          v-model="mercadoria"
              item-value="pkMercadoria"
              item-text="descricao"
              :items="mercadorias"
          label="Mercadoria"
              return-object
        ></v-select>

                  </v-col>
                  <v-card-actions>
                <v-btn   color="green" @click="verificar_datas()">Gerar</v-btn>
                <v-btn  color="blue" @click="reset()">Limpar</v-btn>
              </v-card-actions>
                   </v-row>
              </v-form>

                  </v-row>
 </div>
              </v-card-text>
          </v-col>
          </v-row>
          <!-- Fim Produto -->
              <!-- Ínicio Cliente & Fornecedor -->
           <v-row align="center" justify="center" v-if="callFormClienteFornecedor.estado">
          <v-col cols="12" sm="8" md="12">
              <h2>  {{this.relatorio_Dados.especificacaoRelatorio.descricao}} </h2>
              <v-card-text>
              <div>
                   <v-row >

                          <v-form ref="form" v-model="valid"  lazy-validation>
                   <v-row >
                       <!-- Ínicio Date Picker-->
                    <v-col cols="12" md="12">   <strong>Data de Cadastro</strong></v-col>
          <v-col cols="12" md="3">
             <v-menu
         ref="menu"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date1"
        :rules="ruleTextRequired"
        label="Data ínicio"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date1"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
                       </v-col>
                        <v-col cols="12" md="3">
          <v-menu
         ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date2"
        :rules="ruleTextRequired"
        label="Data ínicio"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date2"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
      <span style="color:red" v-if="periodo > 10"> {{msg1}}</span>
      <span style="color:red" v-if="(-anoMesDia1+anoMesDia2) < 0"> {{msg2}}</span>

                       </v-col>

<!-- Fim Date Picker-->
<!-- Mostrar o Campo cliente this.callFormClienteFornecedor.id===1-->
<v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===1">
          <v-autocomplete
        v-model="cliente"
        :rules="ruleTextRequired"
        item-value="pk_estudante"
        item-text="nome"
        :items="clientes"
        label="Cliente"
        :readonly="false"
        persistent-hint
        prepend-icon="person"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                   <v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===1">
         <v-autocomplete
        v-model="telefone"
        :rules="ruleTextRequired"
        item-value="pk_estudante"
        item-text="telefone"
        :items="clientes"
        label="Telefone"
        :readonly="false"
        persistent-hint
        prepend-icon="stay_current_portrait"
        return-object
      ></v-autocomplete>

                  </v-col>
                   <v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===1">
         <v-autocomplete
        v-model="email"
        :rules="ruleTextRequired"
        item-value="pk_estudante"
        item-text="email"
        :items="clientes"
        label="Email"
        :readonly="false"
        persistent-hint
        prepend-icon="alternate_email"
        return-object
      ></v-autocomplete>

                  </v-col>
                  <!-- Mostrar os Campos do Fornecedor this.callFormClienteFornecedor.id===2-->
                   <v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===2">
          <v-autocomplete
        v-model="fornecedor"
         :rules="ruleTextRequired"
        item-value="pkFornecedor"
        item-text="nome"
        :items="fornecedores"
        :readonly="false"
        label="Fornecedor"
        persistent-hint
        prepend-icon="person"
        return-object
      >
      </v-autocomplete>
 </v-col>
                  <v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===2">
         <v-autocomplete
        v-model="telefone"
         :rules="ruleTextRequired"
        item-value="pkFornecedor"
        item-text="telefone1"
        :items="fornecedores"
        :readonly="false"
        label="Telefone"
        persistent-hint
        prepend-icon="stay_current_portrait"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                   <v-col cols="12" md="3" v-if="this.callFormClienteFornecedor.id===2">
         <v-autocomplete
        v-model="email"
         :rules="ruleTextRequired"
        item-value="pkFornecedor"
        item-text="email"
        :items="fornecedores"
        :readonly="false"
        label="Email"
        persistent-hint
        prepend-icon="alternate_email"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                   <v-col cols="12" md="3">
                         <v-select
          v-model="provincia"
              item-value="idProvincia"
              item-text="descricao"
              :items="provincias"
          label="Província"
              return-object
        ></v-select>

                  </v-col>
                   <v-col cols="12" md="3">
                         <v-select
          v-model="municipio"
              item-value="idMunicipio"
              item-text="descricao"
              :items="municipios"
          label="Município"
              return-object
        ></v-select>

                  </v-col>
                  <v-col cols="12" md="3">
                         <v-select
          v-model="estadoCliente_Fornecedor"
              item-value="pkEstado"
              item-text="descricao"
              :items="estadosCliente_Fornecedor"
          label="Situação"
          disabled
              return-object
        ></v-select>

                  </v-col>
                  <v-col cols="12" md="3">
           <v-autocomplete
        v-model="vendedor"
         :rules="ruleTextRequired"
        item-value="cod"
        item-text="nome"
        :items="vendedores"
        :readonly="true"
        label="Vendedor/Responsavél"
        persistent-hint
        prepend-icon="person"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                  <v-card-actions>
                <v-btn   color="green" @click="verificar_datas()">Gerar</v-btn>
                <v-btn  color="blue" @click="reset()">Limpar</v-btn>
              </v-card-actions>
                   </v-row>
              </v-form>

                  </v-row>
 </div>
              </v-card-text>
          </v-col>
          </v-row>
            <!--Fim Cliente & Fornecedor -->
                     </v-col>
  <!--Fim Form -->

                  </v-row>
  </template>

               </div>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    msg1: '',
    msg2: '',
    ruleTextRequired: [value => !!value || 'campo obrigatorio'],
    date1: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    date2: new Date().toISOString().substr(0, 10),
    menu2: false,
    modal2: false,
    callFormClienteFornecedor: { 'estado': false, 'id': 0 },
    callFormProduto: false,
    valid: false,
    isEditing: false,
    model: null,
    isLoading: true,
    tipoRelatorios: [],
    nome: '',
    anoMesDia1: 0,
    anoMesDia2: 0,
    telefone: { 'pk_estudante': 0, 'telefone': 'Todos' },
    email: { 'pk_estudante': 0, 'email': 'Todos' },
    provincias: [{ 'idProvincia': '%', 'descricao': 'Todas', 'status': 1 }],
    provincia: { 'idProvincia': '%', 'descricao': 'Todas', 'status': 1 },
    municipios: [{ 'idMunicipio': '%', 'idProvincia': 0, 'descricao': 'Todos', 'status_2': 1 }],
    municipio: { 'idMunicipio': '%', 'idProvincia': 0, 'descricao': 'Todos', 'status_2': 1 },
    relatorio: {
      'pkrelatorio': 0,
      'descricao': ''
    },
    relatorios: [
      [
        { 'pkrelatorio': 1, 'descricao': 'Relatório de Vendas' },
        { 'pkrelatorio': 2, 'descricao': 'Relatório de Orçamentos' },
        { 'pkrelatorio': 3, 'descricao': 'Produtos vendidos' },
        { 'pkrelatorio': 4, 'descricao': 'Produtos devolvidos' },
        { 'pkrelatorio': 5, 'descricao': 'Clientes que mais compram' },
        { 'pkrelatorio': 6, 'descricao': 'Comissão por produto' },
        { 'pkrelatorio': 7, 'descricao': 'Relatório de devoluções' },
        { 'pkrelatorio': 8, 'descricao': 'Comissão por venda' }
      ],
      [
        { 'pkrelatorio': 1, 'descricao': 'Compra' },
        { 'pkrelatorio': 2, 'descricao': 'Inventário' },
        { 'pkrelatorio': 3, 'descricao': 'Estoque' },
        { 'pkrelatorio': 4, 'descricao': 'Produtos comprados' }
      ],
      [
        { 'pkrelatorio': 1, 'descricao': 'Extrato' },
        { 'pkrelatorio': 2, 'descricao': 'Contas a pagar' },
        { 'pkrelatorio': 3, 'descricao': 'Contas a receber'
        }
      ],
      [
        { 'pkrelatorio': 1, 'descricao': 'Clientes' },
        { 'pkrelatorio': 2, 'descricao': 'Fornecedores' },
        { 'pkrelatorio': 3, 'descricao': 'Produtos' }
      ]
    ],
    relatorio_Dados: {
      'tipo': 0,
      'descricaoRelatorio': '',
      'especificacaoRelatorio': { 'pkrelatorio': 0, 'descricao': '' },
      'data_in': '',
      'data_fim': '',
      'formaPagamento': { 'pk_forma_pagamento': 0, 'nome': '', 'instituicao': 0, 'status_forma_pagamento': 0 },
      'cliente': {
        'pk_estudante': 0,
        'numero_matricula': 0,
        'saldo': 0,
        'fk_classe': 0,
        'has_multa': 0,
        'nome': '',
        'instituicao': 0,
        'data_cadastro': '',
        'status_estudante': 0,
        'ano_lectivo': 0,
        'municipio': '',
        'pai': '',
        'mae': '',
        'data_nascimento': '',
        'sexo': '',
        'curso': '',
        'numero_documento': '',
        'data_emissao': '',
        'cidade_emissao': '',
        'municipio_emissao': '',
        'rua_casa': '',
        'telefone': '',
        'email': '',
        'turma': '',
        'idmatricula_interno': '',
        'flag_isnew': 0
      },
      'produto':
      { 'pkProduto': '%',
        'descricao': '',
        'descricaoReduzida': '',
        'codigoBarra': '',
        'armazem': 0,
        'tipoProduto': 0,
        'mercadoria': 0,
        'familia': 0,
        'precoCusto': 0.0,
        'precoComIva': 0.0,
        'precoSemIva': 0.0,
        'margem': 0.0,
        'iva': 0,
        'isencao': '',
        'descricaoPreco': '',
        'imagem': '',
        'entrada_stk': 0,
        'saida_stk': 0
      },
      'situacao': { 'pkSituacao': 0, 'descricao': 'Todos' },
      'vendedor': { 'cod': 0, 'nome': '' },
      'estado': { 'pkEstado': 0, 'descricao': 'Todos' },
      'fornecedor': { 'pkFornecedor': 0, 'nome': 'Todos', 'nif': '', 'tipoFornecedor': '', 'morada': '', 'telefone1': '', 'telefone2': '', 'email': '', 'observacao': '' },
      'armazem': { 'pkArmazem': 0, 'descricao': 'Todos', 'status_1': 1 },
      'mercadoria': { 'pkMercadoria': 0, 'descricao': 'Todos', 'fk_tipoProduto': 0, 'status_': 1 },
      'grupo_produto': { 'pkFamiliaProduto': '%', 'descricao': 'Todos', 'status_1': 1, 'codigo': '' },
      'clienteFornecedor_Relatorio': { 'data1': '', 'data2': '', 'nome': '', 'email': '', 'idprovincia': 0, 'idmunicipio': '', 'status_': '0', 'idvendedor': 0, 'isFornecedorOrCliente': 0, 'telefone': '' },
      'produto_Relatorio': { 'pkProduto': '%', 'pkFamilia': '%', 'pkMercadoria': '%', 'pkArmazem': '%' }
    },
    cliente: {
      'pk_estudante': 0,
      'numero_matricula': 0,
      'saldo': 0,
      'fk_classe': 0,
      'has_multa': 0,
      'nome': 'Todos',
      'instituicao': 0,
      'data_cadastro': '',
      'status_estudante': 0,
      'ano_lectivo': 0,
      'municipio': '',
      'pai': '',
      'mae': '',
      'data_nascimento': '',
      'sexo': '',
      'curso': '',
      'numero_documento': '',
      'data_emissao': '',
      'cidade_emissao': '',
      'municipio_emissao': '',
      'rua_casa': '',
      'telefone': 'Todos',
      'email': 'Todos',
      'turma': '',
      'idmatricula_interno': '',
      'flag_isnew': 0
    },
    clientes: [
      {
        'pk_estudante': 0,
        'numero_matricula': 0,
        'saldo': 0,
        'fk_classe': 0,
        'has_multa': 0,
        'nome': 'Todos',
        'instituicao': 0,
        'data_cadastro': '',
        'status_estudante': 0,
        'ano_lectivo': 0,
        'municipio': '',
        'pai': '',
        'mae': '',
        'data_nascimento': '',
        'sexo': '',
        'curso': '',
        'numero_documento': '',
        'data_emissao': '',
        'cidade_emissao': '',
        'municipio_emissao': '',
        'rua_casa': '',
        'telefone': 'Todos',
        'email': 'Todos',
        'turma': '',
        'idmatricula_interno': '',
        'flag_isnew': 0
      }
    ],
    vendedor: { 'cod': 0, 'nome': 'Todos' },
    vendedores: [
      { 'cod': 0, 'nome': 'Todos' },
      { 'cod': 1, 'nome': 'Carlos Alberto' }
    ],
    situacao: { 'pkSituacao': 0, 'descricao': 'Todos' },
    situacoes: [
      { 'pkSituacao': 0, 'descricao': 'Todos' },
      { 'pkSituacao': 1, 'descricao': 'Stock minímo alcançado' },
      { 'pkSituacao': 2, 'descricao': 'Stock máximo alcançado' }
    ],
    produto: { 'pkProduto': '%', 'descricao': 'Tudo', 'descricaoReduzida': '', 'codigoBarra': '', 'armazem': 0, 'tipoProduto': 0, 'mercadoria': 0, 'familia': 0, 'precoCusto': 0.0, 'precoComIva': 0.0, 'precoSemIva': 0.0, 'margem': 0.0, 'iva': 0, 'isencao': '', 'descricaoPreco': '', 'imagem': '', 'entrada_stk': 0, 'saida_stk': 0 },
    produtos: [
      {
        'pkProduto': '%',
        'descricao': '',
        'descricaoReduzida': '',
        'codigoBarra': '',
        'armazem': 0,
        'tipoProduto': 0,
        'mercadoria': 0,
        'familia': 0,
        'precoCusto': 0,
        'precoComIva': 0,
        'precoSemIva': 0,
        'margem': 0,
        'iva': 0,
        'isencao': ' ',
        'descricaoPreco': '',
        'imagem': '',
        'entrada_stk': 0,
        'saida_stk': 0
      }
    ],
    grupo_produto: { 'pkFamiliaProduto': '%', 'descricao': 'Todos', 'status_1': 1, 'codigo': '' },
    grupo_produtos: [
      { 'pkFamiliaProduto': '%', 'descricao': 'Todos', 'status_1': 1, 'codigo': '' }
    ],
    estado: { 'pkEstado': 0, 'descricao': 'Todos' },
    estados: [
      { 'pkEstado': 0, 'descricao': 'Todos' },
      { 'pkEstado': 1, 'descricao': 'Activo' },
      { 'pkEstado': 2, 'descricao': 'Esgotado' }
    ],
    estadoCliente_Fornecedor: { 'pkEstado': 0, 'descricao': 'Todos' },
    estadosCliente_Fornecedor: [
      { 'pkEstado': 0, 'descricao': 'Todos' },
      { 'pkEstado': 1, 'descricao': 'Activo' },
      { 'pkEstado': 2, 'descricao': 'Inativo' }
    ],
    fornecedor:
      { 'pkFornecedor': '0', 'nome': 'Todos', 'nif': '', 'tipoFornecedor': '', 'morada': '', 'telefone1': 'Todos', 'telefone2': 'Todos', 'email': 'Todos', 'observacao': '' },
    fornecedores: [
      { 'pkFornecedor': '0', 'nome': 'Todos', 'nif': '', 'tipoFornecedor': '', 'morada': '', 'telefone1': 'Todos', 'telefone2': 'Todos', 'email': 'Todos', 'observacao': '' }
    ],
    armazem: { 'pkArmazem': '%', 'descricao': 'Todos', 'status_1': 1 },
    armazens: [
      { 'pkArmazem': '%', 'descricao': 'Todos', 'status_1': 1 }
    ],
    mercadoria: { 'pkMercadoria': '%', 'descricao': 'Todos', 'fk_tipoProduto': 0, 'status_': 1 },
    mercadorias: [
      { 'pkMercadoria': '%', 'descricao': 'Todos', 'fk_tipoProduto': 0, 'status_': 1 }
    ],
    periodo: 0

  }),
  created () {
    this.isLoading = true
    this.relatorio_Dados = ls.get('relatoriosVendas')
    this.tipoRelatorios = this.relatorios[(this.relatorio_Dados.tipo) - 1]
    this.isLoading = true
    this.relatorio_Dados = ls.get('relatoriosVendas')
  },

  methods: {
    relatoriosVendas (item) {
      this.relatorio_Dados.especificacaoRelatorio = item
      ls.set('relatoriosVendas', this.relatorio_Dados)
      this.fornecedor_()
      setTimeout(() => {
        if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 3) {
          this.produto_()
          this.grupo_produto_()
          this.armazem_()
          this.mercadoria_()
          this.callFormProduto = true
          this.callFormClienteFornecedor.id = 0
          this.callFormClienteFornecedor.estado = false
        } else {
          this.cliente_()
          this.provincia_()
          this.municipio_()
          if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 1) {
            this.callFormClienteFornecedor.id = 1
            this.telefone = { 'pk_estudante': 0, 'telefone': 'Todos' }
            this.email = { 'pk_estudante': 0, 'email': 'Todos' }
          } else

          if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 2) {
            this.callFormClienteFornecedor.id = 2
            this.telefone = { 'pkFornecedor': 0, 'telefone1': 'Todos', 'telefone2': 'Todos' }
            this.email = { 'pkFornecedor': 0, 'email': 'Todos' }
          }
          this.callFormProduto = false
          this.callFormClienteFornecedor.estado = true
        }
      }, 200)
    },

    // Ínicio Formulario
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
      this.defaultForm(this.relatorio_Dados.especificacaoRelatorio)
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async produto_ () {
      try {
        this.produtos = await axios
          .get('/produto')
          .then(res => res.data)
        this.isLoading = false
        this.produtos.unshift({ 'pkProduto': '%', 'descricao': 'Todos', 'descricaoReduzida': '', 'codigoBarra': '', 'armazem': 0, 'tipoProduto': 0, 'mercadoria': 0, 'familia': 0, 'precoCusto': 0.0, 'precoComIva': 0.0, 'precoSemIva': 0.0, 'margem': 0.0, 'iva': 0, 'isencao': '', 'descricaoPreco': '', 'imagem': '', 'entrada_stk': 0, 'saida_stk': 0 })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async grupo_produto_ () {
      try {
        this.grupo_produtos = await axios
          .get('/grupo_produto')
          .then(res => res.data)
        this.isLoading = false
        this.grupo_produtos.unshift({ 'pkFamiliaProduto': '%', 'descricao': 'Todos', 'status_1': 1, 'codigo': '' })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async cliente_ () {
      try {
        this.clientes = await axios
          .get('/cliente')
          .then(res => res.data)
        this.isLoading = false
        this.clientes.unshift({ 'pk_estudante': 0, 'nome': 'Todos', 'telefone': 'Todos', 'email': 'Todos' })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async fornecedor_ () {
      try {
        this.fornecedores = await axios
          .get('/fornecedor')
          .then(res => res.data)
        this.isLoading = false
        this.fornecedores.unshift({ 'pkFornecedor': '0', 'nome': 'Todos', 'nif': '', 'tipoFornecedor': '', 'morada': '', 'telefone1': 'Todos', 'telefone2': 'Todos', 'email': 'Todos', 'observacao': '' })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async armazem_ () {
      try {
        this.armazens = await axios
          .get('/armazem')
          .then(res => res.data)
        this.isLoading = false
        this.armazens.unshift({ 'pkArmazem': '%', 'descricao': 'Todos', 'status_1': 1 })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async mercadoria_ () {
      try {
        this.mercadorias = await axios
          .get('/mercadoria')
          .then(res => res.data)
        this.isLoading = false
        this.mercadorias.unshift({ 'pkMercadoria': '%', 'descricao': 'Todos', 'fk_tipoProduto': 0, 'status_': 1 })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async provincia_ () {
      try {
        this.provincias = await axios
          .get('/provincia')
          .then(res => res.data)
        this.isLoading = false
        this.provincias.unshift({ 'idProvincia': '%', 'descricao': 'Todos', 'status': 1 })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async municipio_ () {
      try {
        this.municipios = await axios
          .get('/municipio')
          .then(res => res.data)
        this.isLoading = false
        this.municipios.unshift({ 'idMunicipio': '%', 'idProvincia': 0, 'descricao': 'Todos', 'status_2': 1 })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    gerarRelatorio () {
      if (this.date1 && this.date2 && (-this.anoMesDia1 + this.anoMesDia2) >= 0 && this.periodo <= 10) {
        this.relatorio_Dados.data_in = this.date1
        this.relatorio_Dados.data_fim = this.date2
        this.relatorio_Dados.cliente = this.cliente
        this.relatorio_Dados.produto = this.produto
        this.relatorio_Dados.situacao = this.situacao
        this.relatorio_Dados.vendedor = this.vendedor

        /** Escolhendo formulario 0-Produto 1-Cliente 2-Fornecedor  */
        if (this.callFormClienteFornecedor.id === 1) {
          if (this.telefone.pk_estudante === 0) this.telefone.telefone = '%' // Trazer todos telefones
          if (this.email.pk_estudante === 0) this.email.email = '%' // Trazer todos email
          if (this.cliente.pk_estudante === 0) this.cliente.nome = '%'
          if (this.estadoCliente_Fornecedor.pkEstado === 0) this.estadoCliente_Fornecedor.pkEstado = '%'

          this.relatorio_Dados.clienteFornecedor_Relatorio = { 'data1': this.date1, 'data2': this.date2, 'nome': this.cliente.nome, 'email': this.email.email, 'idprovincia': this.provincia.idProvincia, 'idmunicipio': this.municipio.idMunicipio, 'status_': '' + this.estadoCliente_Fornecedor.pkEstado, 'idvendedor': 0, 'isFornecedorOrCliente': this.callFormClienteFornecedor.id, 'telefone': this.telefone.telefone }
        } else {
          if (this.callFormClienteFornecedor.id === 2) {
            if (parseInt(this.telefone.pkFornecedor) === 0) this.telefone.telefone1 = '%' // Trazer todos telefones
            if (parseInt(this.email.pkFornecedor) === 0) this.email.email = '%' // Trazer todos email
            if (parseInt(this.fornecedor.pkFornecedor) === 0) this.fornecedor.nome = '%'
            if (parseInt(this.estadoCliente_Fornecedor.pkEstado) === 0) this.estadoCliente_Fornecedor.pkEstado = '%'
            this.relatorio_Dados.clienteFornecedor_Relatorio = { 'data1': this.date1, 'data2': this.date2, 'nome': this.fornecedor.nome, 'email': this.email.email, 'idprovincia': this.provincia.idProvincia, 'idmunicipio': this.municipio.idMunicipio, 'status_': '' + this.estadoCliente_Fornecedor.pkEstado, 'idvendedor': 0, 'isFornecedorOrCliente': this.callFormClienteFornecedor.id, 'telefone': this.telefone.telefone1 }
          } else {
          // Guardando os valores do formulario 0
            this.relatorio_Dados.produto_Relatorio = { 'pkProduto': this.produto.pkProduto, 'pkFamilia': this.grupo_produto.pkFamiliaProduto, 'pkMercadoria': this.mercadoria.pkMercadoria, 'pkArmazem': this.armazem.pkArmazem }
          }
        }
        setTimeout(() => {
          // Guardar e enviar os dados que foram recolhidos para o relatório
          ls.set('relatoriosVendas', this.relatorio_Dados)
          this.$router.push('/imprimir_relatorio_cadastro')
        }, 1000)
      } else {
        if (!this.date1) { this.date1 = '' }
        if (!this.date2) { this.date2 = '' }
        this.msg1 = 'Período excedido, eperava-se um período entre 1 à 10 anos'
        this.msg2 = 'A data de ínicio deve ser menor que a do fim'
        setTimeout(() => {
          this.msg1 = ''
          this.msg2 = ''
        }, 900)
      }
    },
    defaultForm (item) {
      // Colocar o email e o telefone com o seu valor padrão
      this.relatoriosVendas(item)
      if (item.pkrelatorio === 1) {
        this.cliente = {
          'pk_estudante': 0,
          'numero_matricula': 0,
          'saldo': 0,
          'fk_classe': 0,
          'has_multa': 0,
          'nome': 'Todos',
          'instituicao': 0,
          'data_cadastro': '',
          'status_estudante': 0,
          'ano_lectivo': 0,
          'municipio': '',
          'pai': '',
          'mae': '',
          'data_nascimento': '',
          'sexo': '',
          'curso': '',
          'numero_documento': '',
          'data_emissao': '',
          'cidade_emissao': '',
          'municipio_emissao': '',
          'rua_casa': '',
          'telefone': 'Todos',
          'email': 'Todos',
          'turma': '',
          'idmatricula_interno': '',
          'flag_isnew': 0
        }
      } else
      if (item.pkrelatorio === 3) {
        this.mercadoria = { 'pkMercadoria': '%', 'descricao': 'Todos', 'fk_tipoProduto': 0, 'status_': 1 }
        this.armazem = { 'pkArmazem': '%', 'descricao': 'Todos', 'status_1': 1 }
        this.grupo_produto = { 'pkFamiliaProduto': '%', 'descricao': 'Todos', 'status_1': 1, 'codigo': '' }
        this.produto = { 'pkProduto': '%', 'descricao': 'Tudo', 'descricaoReduzida': '', 'codigoBarra': '', 'armazem': 0, 'tipoProduto': 0, 'mercadoria': 0, 'familia': 0, 'precoCusto': 0.0, 'precoComIva': 0.0, 'precoSemIva': 0.0, 'margem': 0.0, 'iva': 0, 'isencao': '', 'descricaoPreco': '', 'imagem': '', 'entrada_stk': 0, 'saida_stk': 0 }
        this.situacao = { 'pkSituacao': 0, 'descricao': 'Todos' }
      }
      this.fornecedor = { 'pkFornecedor': '0', 'nome': 'Todos', 'nif': '', 'tipoFornecedor': '', 'morada': '', 'telefone1': 'Todos', 'telefone2': 'Todos', 'email': 'Todos', 'observacao': '' }

      this.estadoCliente_Fornecedor = { 'pkEstado': 0, 'descricao': 'Todos' }
      this.estado = { 'pkEstado': 0, 'descricao': 'Todos' }
      this.vendedor = { 'cod': 0, 'nome': 'Todos' }
      this.provincia = { 'idProvincia': '%', 'descricao': 'Todas', 'status': 1 }
      this.municipio = { 'idMunicipio': '%', 'idProvincia': 0, 'descricao': 'Todos', 'status_2': 1 }
    },
    verificar_datas () {
      let dateIni = this.date1.replace('-', '')
      let dateFim = this.date2.replace('-', '')
      this.anoMesDia2 = parseInt(dateFim.substr(0, 6) + '' + dateFim.substr(7, 9))
      this.anoMesDia1 = parseInt(dateIni.substr(0, 6) + '' + dateIni.substr(7, 9))
      this.periodo = (-parseInt(this.date1.substr(0, 4)) + parseInt(this.date2.substr(0, 4)))
      this.gerarRelatorio()
    }
    // Fim Formulario
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
